import React from "react";
import { addCustomerEffect } from "../../../../stores/CustomersStore/CustomersStore.effects";
import { AddButton } from "../../../../components/Table";
import CustomerFormModal from "../CustomerFormModal/CustomerFormModal";

const AddCustomer: React.FC = () => {
  return (
    <CustomerFormModal
      effect={addCustomerEffect}
      title="Adicionar cliente"
      confirmText="Confirmar"
      cancelText="Cancelar"
      TriggerComponent={
        <AddButton>Adicionar cliente</AddButton>
      }
    />
  );
};

export default AddCustomer;
